import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import MaskedInput from "react-text-mask";
import { StringUtil } from "@eres/core";
import Popup from "@my-dld/components/Popup/Popup";
import { AppConstants } from "../../configApp";
import { resendAccessToken, verifyAccessToken } from "../api/api";
import { TokenAccess } from "../api/entities";
import { exToMessage } from "@eres/ssoapi/api";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface VProps {
	requestId: string;
	onConfirmed: ( tokens: TokenAccess[] ) => void;
	onCancel: () => void;
}

interface VSate {
	accessCode: string;
	formErrors: { [ k: string ]: string | undefined };
	error?: string;
	isLoading: boolean;
}

class VerifyAccess extends Component<VProps, VSate> {

	isVerified = false;

	constructor( props: VProps ) {
		super( props );
		this.state = {
			isLoading: false,
			formErrors: {},
			accessCode: "",
		};
	}


	xChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
		e.target.value = "";
	};

	render() {
		const { formErrors, error, isLoading } = this.state;
		const isValid = this.isValid();
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};

		return <>
			<Popup
				id="vault-verify-pop" autoOpenMount={ true } showIcon={ false } clickOutsideToDismiss={ false }
				onDismiss={ this.onDismiss }>
				<div className="text-center">
					<img
						className="mt-3 mb-3"
						src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
				</div>
				<div className="text-center">
					<strong>{ Strings.verification }</strong>
				</div>
				<p className="mt-3 text-center passCode-msg mb-0">{ Strings.we_sent_otp_to_vault_owner }</p>
				<p className="mt-3 text-center passCode-msg mb-0">
					{ Strings.please_enter_the_verification_code }
				</p>
				{/* this is here to disable chrome password prompt*/ }
				<div className={ "" } style={ { height: 0, overflow: "hidden" } }>
					<input type="text" name="username" placeholder="username"/>
					<input type="password" name="dpwd"/>
				</div>

				<TextInputField
					{ ...formProps }
					id={ "accessCode" }
					error={ formErrors.accessCode }
					label={ Strings.enter_otp }
					noLabel={ true }
					required={ true }
					maxLength={ 12 }
					containerClassName={ "mt-1 mb-4 text-center" }
					inputClassName={ "vault-otp-field text-center" }
					inputProps={ { type: "password", autoComplete: "off" } }
					customInput={ <MaskedInput
						keepCharPositions={ true }
						guide={ false }
						placeholderChar={ " " }
						name={ "accessCode" }
						autoComplete={ "off" }
						mask={ [ /\d/, /\d/, /\d/, /\d/, /\d/, /\d/ ] }
					/> }
					onValueChange={ ( value, extra ) => {
						this.validateOTP( value, "accessCode" );
					} }
				>
					<div className="btn-resend">
						<button onClick={ this.resend } className={ "" }>
							{ !this.state.isLoading ?
								Strings.resend :
								<div>
								</div> }
						</button>
					</div>
				</TextInputField>

				<div className="form-group btn-proceed text-center">
					<button
						className="btn btn_1 btn_style1 otp-btn" disabled={ !( isValid && !isLoading ) }
						onClick={ this.onConfirm }>{ !isLoading ? Strings.verify : "" }
						{ isLoading && <div className="relative spinner-border " role="status">
							<span className="sr-only">{ Strings.loading }</span>
						</div> }

					</button>
				</div>
				{ error && <div className="invalid-feedback invalid-feedback-x">
					{ error }
				</div> }
			</Popup>
		</>;
	}

	onDismiss = () => {
		if ( !this.isVerified ) {
			this.props.onCancel();
		}
	};


	resend = () => {
		const key = "accessCode";
		this.setError( key, undefined );
		this.setState( {
			isLoading: true,
		} );
		const reqId = this.props.requestId;
		resendAccessToken( reqId ).then( x => {
			this.setState( {
				isLoading: false,
			} );
		} ).catch( e => {
			this.setState( { isLoading: false } );
			exToMessage( e ).then( message => {
				this.setError( key, message.error );
			} );
		} );
	};

	validateOTP = ( value: string, key: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( key, Strings.form_required_label );
		} else if ( value.length < 4 ) {
			this.setError( key, Strings.invalid_otp );
		} else {
			this.setError( key, undefined );
		}
	};
	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	isValid = () => {
		window.$( "dpwd" ).val( "" );
		let isError = StringUtil.isEmptyStringOrNull( this.state.accessCode );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};
	onConfirm = () => {
		this.setState( { isLoading: true } );
		const accessCode = this.state.accessCode;
		const reqId = this.props.requestId;
		verifyAccessToken( reqId, accessCode ).then( x => {
			JQModal( "vault-verify-pop" ).hide( () => {
				this.props.onConfirmed( x.data );
			} );
		} ).catch( e => {
			this.setState( { isLoading: false } );
			exToMessage( e ).then( message => {
				let key = "accessCode";
				this.setError( key, message.error );
			} );
		} );

	};

}

export default VerifyAccess;
